import { Tab } from "@mui/material";
import React from "react";
import LineChart from "./Charts/Revenue/Line";
import BarChart from "./Charts/Revenue/Bar";
import DiversityBar from "./Charts/Revenue/DiversityBar";
import ScatterChart from "./Charts/Revenue/Scatter";
import ChartTabs from "../../Common/ChartTabs";
import SalesPerformance from "./Charts/Revenue/SalesPerformance";

export default function MonthlySales({ height }: { height: number }){
    const [revenuePerMonth, setRevenuePerMonth] = React.useState([]);
    const [categories, setCategories] = React.useState([]);

    React.useEffect(() => {
        fetch(`/dashboard/revenue-per-month/?entity_id=${localStorage.getItem('entity_id')}`)
            .then(response => response.json())
            .then(data => {
                setCategories(data.categories);
                setRevenuePerMonth(data.revenue_per_month);
            });
    }, [localStorage.getItem('entity_id')]);

    return (
        <ChartTabs 
            tabs={[
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Monthly Sales" value="0" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Product Sales" value="1" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Diversity of Sales" value="2" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Sales Mix" value="3" />,
                <Tab wrapped style={{ textTransform: 'capitalize' }} label="Sales Performance" value="4" />
            ]} 
            values={["0", "1", "2", "3", "4"]} 
            ariaLabel="revenue tabs"
            panels={[
                <LineChart data={revenuePerMonth} categories={categories} title="Monthly Sales Trend" height={height} />,
                <BarChart title="Current Sales and Incremental Sales Opportunity" height={height} />,
                <DiversityBar title="Number of Unique Products Purchased Annually" height={height} />,
                <ScatterChart title="Annual Sales vs Share Sold from Stock" height={height} />,
                <SalesPerformance title="Sales Performance" height={height} />
            ]}
        >
        </ChartTabs>
    )
}